module.exports = __webpack_public_path__ + "e34b39178586991b23e5ffa378a30dea.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/trailer_preview-460.jpg
// module id = 560
// module chunks = 0